import { Pipe, PipeTransform } from '@angular/core';
import activitiesText from "./activities-list/activities-text.json";
import {Utils} from "../../shared/utils/utils";
import {TypeUtils} from "../../shared/utils/type-utils";

@Pipe({
    name: 'activitiesText',
    standalone: false
})
export class ActivitiesTextPipe implements PipeTransform {

  transform(text: string, params: any = null ): string | null {
    return getText(text, params) || text;
  }

}

const templateMatcher: RegExp = /{{\s?([^{}\s]*)\s?}}/g;

function getText(text: string, params: any = null ): string {
  return interpolateString(activitiesText[text], params) || text;
}

function interpolateString(string: string, params: any): string {
  if (!params || !string) {
    return string;
  }
  return string.replace(templateMatcher, (substring: string, paramKeyChain: string) => {
    const value = Utils.getValueByKeyChain(params, paramKeyChain);
    return TypeUtils.isDefined(value) ? value : substring;
  });
}
